import { Component } from 'react';
import FacetFieldCheckboxes from './FacetFieldCheckboxes';
import { connectTeamsTheme } from './../../../context/connectTeamsTheme';
import {
  ChevronDown32Filled as ChevronDownIcon,
  ChevronRight32Filled as ChevronRightIcon,
  Search32Filled as SearchIcon,
} from '@fluentui/react-icons';
import { Button, Input, Spinner } from '@fluentui/react-components';
import { FacetValue, FacetValueCount, FacetValues, StringFacetValue } from '../../../types/Facet';
import { DisplayMode, DisplayModes } from './Types';

const DEFAULT_FACET_VALUE_COUNT : number = 10;

/**
 * Represents the properties for the StringFacet component.
 *
 * @property fullView - Indicates if the facet is in full view mode, meaning all the facet values are displayed.
 */
interface StringFacetTemplateProps {
  facetValues: FacetValueCount<StringFacetValue>[];
  facetSelection: FacetValues<StringFacetValue> |  null;
  displayName: string;
  onChangeFacet: (name: string, value: FacetValue, checked: boolean) => void;
  name: string;
  toggleDisplayMode: (name: string, mode: DisplayMode) => void;
  isExpanded: boolean;
  isExecutingSearch: boolean;
  displayMode: DisplayMode
}

interface StringFacetTemplateState {
  isExpanded: boolean;
  term: string
}

class StringFacetTemplate extends Component<StringFacetTemplateProps, StringFacetTemplateState> {
  constructor(props: StringFacetTemplateProps) {
    super(props);
    this.state = {
        isExpanded: this.props.isExpanded,
        term: ''
    };
  }

  setTerm = (term: string) => {    
    this.setState({ term });
};

  handleSectionExpand = () => this.setState(({ isExpanded }) => ({ isExpanded: !isExpanded }));

 
  render() {    
    const facetValues = this.props.displayMode === DisplayModes.FULL ? this.props.facetValues : this.props.facetValues.slice(0, DEFAULT_FACET_VALUE_COUNT);
    const facetSelection = this.props.facetSelection;
    
    let facetValuesToDisplay;
    if (this.state.term) {
      facetValuesToDisplay = facetValues.filter((facetValue: FacetValueCount<StringFacetValue>) => 
        facetValue.facetValue.value.toLowerCase().includes(this.state.term.toLowerCase()));
    }   
    else {
        facetValuesToDisplay= facetValues;
    }
    
    const showSeeMoreButton = facetValues.length === DEFAULT_FACET_VALUE_COUNT;
    const showFacetValueFilter = facetValues.length > DEFAULT_FACET_VALUE_COUNT && facetValues.length > DEFAULT_FACET_VALUE_COUNT;
    
    const { handleSectionExpand, state } = this;
    const { isExpanded } = state;
    return (
      <>
        <section className={`search-fragment ${isExpanded ? 'expanded' : ''}`}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <header
              className={facetSelection && facetSelection.facetValues.length > 0 ? 'active' : ''}
              onClick={() => handleSectionExpand()}
            >
              <Button
                appearance="transparent"
                icon={isExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
              />
              {this.props.displayName}
            </header>
          </div>
          <div className="support-content">
            <ul>
                {showFacetValueFilter && (
                    <Input
                        contentAfter={<SearchIcon />}
                        value={this.state.term}                
                        placeholder="Search..."
                        onChange={(e) => this.setTerm(e.target.value === undefined ? '' : e.target.value)}
                    />
                )}
               {this.props.isExecutingSearch && this.props.isExpanded ? (
                  <Spinner size="medium" label="Loading..." />
                ) : (
                    <>
                        <FacetFieldCheckboxes
                            facetValues={facetValuesToDisplay}
                            facetSelection={facetSelection}
                            onChangeFacet={this.props.onChangeFacet}
                            name={this.props.name}
                        />
                        {showSeeMoreButton && (
                        <Button
                            appearance="transparent"                
                            onClick={() => this.props.toggleDisplayMode(this.props.name, DisplayModes.FULL)}
                        >
                            See more...
                        </Button>
                        )}
                  </>                    
                )}
            </ul>            
          </div>
        </section>
      </>
    );
  }
}

const StringFacet = connectTeamsTheme(StringFacetTemplate);
export default StringFacet;
